if(document.querySelector('.template-cart')){
  document.querySelectorAll('.cart__remove a').forEach( (link) => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      let href = event.target.dataset.href;
      let id = event.target.dataset.id;
      
      if(!id) window.location.href = href;

      let items = {};
      document.querySelectorAll('.cart__item[data-master="' + id + '"]').forEach( (addon) => {
        let addonId = addon.dataset.id;
        items[addonId] = 0;
      });

      if(items) {
        const data = { 'updates': items };
        fetch(window.theme.routes.cartUpdate, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
          .then((response) => response.json())
          .then(() => {
            window.location.href = href
          })
          .catch((error) => { console.log(error); window.location.href = href; });
      } else {
        window.location.href = href;
      }
    });
  })
}